import React from "react"
import {Box} from "@mui/material"
import ButtonTemplate from "./ButtonTemplate"

const GhostButtonWidget = ({widget,value, payload, triggerAction}) => {

    return (
        <Box display="flex" flexDirection="column" alignItems={widget.align ?? 'center'}>
            <ButtonTemplate
                buttonText={widget.text}
                actionType={widget.action}
                startIcon={widget.startIcon}
                endIcon={widget.endIcon}
                variant={"ghost"}
                payload={payload ?? value}
                color="inherit"
                triggerAction={triggerAction}
                onClick={widget.onClick}
            />
        </Box>
    )
}

export default GhostButtonWidget
